export default [
  {
    name: 'agency-create',
    path: '/agencies/create',
    component: () => import('@/views/agencies/AgencyManage')
  },
  {
    name: 'agency-edit',
    path: '/agencies/:id/edit',
    component: () => import('@/views/agencies/AgencyManage')
  },
  {
    name: 'agency-view',
    path: '/agencies/:id/view',
    component: () => import('@/views/agencies/AgencyManage')
  },
  {
    name: 'agency-find',
    path: '/agencies/find',
    component: () => import('@/views/agencies/AgencyFind')
  },
  {
    name: 'agency-transfer',
    path: '/agencies/transfer',
    component: () => import('@/views/agencies/transfer/AgencyTransfer')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeAgencies.js